
import { getStories, getStoryBySlug, getStoriesByCategory, getFeaturedStories } from './storyService';
import { testConnection } from './diagnostics';
import { getContentfulCredentials } from './contentfulClient';
import { createClient } from 'contentful';

// Function to get all tags from Contentful blogPost content type
const getAllTags = async (): Promise<string[]> => {
  try {
    const credentials = getContentfulCredentials();
    
    if (!credentials.spaceId || !credentials.accessToken) {
      console.error('Missing Contentful credentials');
      return [];
    }
    
    const client = createClient({
      space: credentials.spaceId,
      accessToken: credentials.accessToken,
    });
    
    console.log('Fetching all tags from Contentful blogPost content type...');
    
    // Fetch entries from the blogPost content type
    const response = await client.getEntries({
      content_type: 'blogPost',
      select: ['fields.tags'],
      limit: 1000
    });
    
    // Extract and flatten all tags
    const allTags: string[] = [];
    response.items.forEach(entry => {
      const tags = entry.fields.tags;
      if (Array.isArray(tags)) {
        tags.forEach(tag => {
          if (tag && typeof tag === 'string' && !allTags.includes(tag)) {
            allTags.push(tag);
          }
        });
      }
    });
    
    console.log(`Found ${allTags.length} unique tags from blogPost content type`);
    return allTags.sort();
    
  } catch (error) {
    console.error('Error fetching tags from Contentful:', error);
    return [];
  }
};

// Re-export everything as a single service object
const contentfulService = {
  getStories,
  getStoryBySlug,
  getStoriesByCategory,
  getFeaturedStories,
  testConnection,
  getContentfulCredentials,
  getAllTags
};

export default contentfulService;
